
















































import firebase from "firebase";
import { reactive, ref, Ref, SetupContext, defineComponent, onMounted, } from '@vue/composition-api';
import * as Auth from "@/models/auth";

const useNav = (context: SetupContext) => {
  const navState = reactive({
    drawer: true,
    mini: true,
    show_user: false,
  });

  const snackbar = reactive({
    on: false,
    timeout: 3000,
    text: "",
    cssclass: "",
  });

  function pop_snackbar(payload: { text: string, cssclass?: string }) {
    console.log(payload)
    snackbar.text = payload.text
    snackbar.cssclass = payload.cssclass || ""
    snackbar.on = true
  }

  function go(path: string) {
    context.root.$router.push(path)
  }

  return {
    navState,
    snackbar,
    pop_snackbar,
    go,
  };
};

export default defineComponent({

  setup(props: {}, ctx: SetupContext) {
    console.log(props, ctx);
    const userAuth = Auth.useUserAuth(ctx);

    onMounted(() => {
      userAuth.observeUser()
    })

    return {
      ...useNav(ctx),
      ...userAuth,
    }
  }
});

